import { useEffect, useState } from "react";
import styled from "styled-components";
import { CenterView, Icon } from "../style/common_style";

const PageDiv = styled.div`
  width: 100%;
  margin-top: 3rem;
  display: flex;
  justify-content: center;
  text-align: center;
  &.under {
    margin-bottom: 8rem;
  }
`;
const PageNum = styled(CenterView)`
  width: 2.2rem;
  height: 2.2rem;
  margin-left: 0.5rem;
  color: var(--admin-theme-text, #4e4e4e);
  font-size: 15px;
  border-radius: 50px;
  border: 1px solid var(--admin-theme-border, #f0f0f0);
  cursor: pointer;
  &:hover {
    background-color: var(--admin-theme-raised, #f0f0f0);
  }
  &.currentPage {
    border: 1px solid var(--admin-theme-border, #f0f0f0);
    background-color: var(--admin-theme-raised, #f0f0f0);
  }
`;
const PageArrowBtn = styled(CenterView)`
  width: 2.2rem;
  height: 2.2rem;
  border: 1px solid var(--admin-theme-border, #e7e7e7);
  border-radius: 50px;
  &.first {
    margin-right: 0.2rem;
  }
  &.end {
    margin-left: 0.5rem;
  }
  img {
    filter: var(--admin-theme-icon-filter, none);
    cursor: pointer;
  }
  .gray {
    cursor: default;
  }
`;

interface Paging {
  cnt: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  perPage?: number;
  maxPaging?: number;
}

const PagingControl = (props: Paging) => {
  const cnt = props.cnt;
  const currentPage = props.currentPage;
  const setCurrentPage = props.setCurrentPage;
  const perPage = props.perPage || 20;
  const maxPaging = props.maxPaging || 10; // 1 2 3 .. 이거 몇개 보여줄건지

  const finalPagenum =
    cnt % perPage > 0
      ? Math.floor(cnt / perPage) + 1
      : Math.floor(cnt / perPage);

  const [pageArray, setPageArray] = useState<any[]>([]);
  const paging = () => {
    const startToend_num = Math.floor((currentPage - 1) / maxPaging);
    let new_arr: any[] = [];

    for (
      let i = startToend_num * maxPaging + 1;
      i <= (startToend_num + 1) * maxPaging && i <= finalPagenum;
      i++
    ) {
      new_arr.push(i);
    }
    setPageArray(new_arr);
  };
  useEffect(() => {
    paging();
  }, [currentPage, cnt]);

  const handlePageChange = (where: string) => {
    if (
      (where === "pre" && currentPage > 1) ||
      (where === "next" && currentPage < finalPagenum)
    ) {
      const num = where === "next" ? 1 : -1;
      setCurrentPage(currentPage + num);
    }
  };
  const pageBack = () => handlePageChange("pre");
  const pageGo = () => handlePageChange("next");

  return (
    <PageDiv>
      <PageArrowBtn className="first" onClick={pageBack}>
        <Icon
          className={currentPage === 1 ? "gray" : ""}
          src={require("../../Image/Admin/ic_paging_left.png")}
        />
      </PageArrowBtn>

      {cnt === 0 ? (
        <PageNum className="currentPage">1</PageNum>
      ) : (
        pageArray.map((num, idx) => {
          return (
            <PageNum
              key={idx}
              className={currentPage === num ? "currentPage" : ""}
              onClick={() => setCurrentPage(num)}
            >
              {num}
            </PageNum>
          );
        })
      )}

      <PageArrowBtn className="end" onClick={pageGo}>
        <Icon
          className={cnt === 0 || currentPage === finalPagenum ? "gray" : ""}
          src={require("../../Image/Admin/ic_paging_right.png")}
        />
      </PageArrowBtn>
    </PageDiv>
  );
};

export default PagingControl;
